import React from "react";
import ExperienceSlider from "@components/ExperienceSlider";
import FeatureFilm from "@components/FeatureFilm";
import ComingSoon from "@components/V3/ComingSoon";
import CurrentlyShowing from "@components/V3/CurrentlyShowing";
import V3Carousel from "@components/V3/V3Carousel";
import VersionedLayout from "@components/Wrappers/VersionedLayout";

const MovieRewardsSearchPage = () => {

    return (
        <VersionedLayout>
            <V3Carousel />
            <div className="layout__inner--home">
                <CurrentlyShowing />
                <FeatureFilm />
                <ComingSoon />
                <ExperienceSlider />
            </div>
        </VersionedLayout>
    );
};

export default MovieRewardsSearchPage;
